// Global debug flag for controlling all browser logs
export const DEBUG_LOGS_ENABLED = false; // Set to true to enable debug logs
